import { Route } from 'src/routes/Route'

export const PricingRoute = Route({
  path: '/pricing',
  init: (plan?: string, affiliate: boolean = false) => ({ plan, affiliate }),
  fromPath: variables => ({
    plan: variables.plan,
    affiliate: 'affiliate' in variables,
  }),
})
export type PricingRoute = Route<typeof PricingRoute>
